import { render } from "./Confirmation.vue?vue&type=template&id=4f566f1d&scoped=true"
import script from "./Confirmation.vue?vue&type=script&lang=ts"
export * from "./Confirmation.vue?vue&type=script&lang=ts"

import "./Confirmation.vue?vue&type=style&index=0&id=4f566f1d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4f566f1d"

export default script